import { Component, OnInit, Input, Output, EventEmitter, ContentChildren, QueryList, AfterContentInit, TemplateRef } from '@angular/core';
import { TemplateDirective } from '../../directives/template.directive';

@Component({
  selector: 'lib-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit /*, AfterContentInit*/ {

  @Input() logo: string;
  @Input() name: string;
  @Input() userInfo: any = {};
  @Input() menu: any[];
  @Input() logoImageSrc: string;

  @Input() opened: boolean = true;
  @Output() toogle: EventEmitter<any> = new EventEmitter();

  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;

  @Input() toolbarElementsTemplate: TemplateRef<any> = null;

  constructor() { }

  ngOnInit() {
  }

  // ngAfterContentInit() {
  //   this.getToolbarElementTemplate();
  // }

  handleToogleMenu = () => {
    this.toogle.emit();
  }

  // private getToolbarElementTemplate = () => {
  //   const tpl = this.templates.find(temp => temp.getType() == 'toolbar-element');
  //   if (tpl) {
  //     this.toolbarElementsTemplate = tpl.template;
  //   }
  // }

}
